const ACCREDITATION_TYPE_OTHER = '5'
const ACCREDITATION_TYPE_IAS = '2'

// Helper function to set element visibility and aria-hidden
function setElementVisibility(element: HTMLElement, isVisible: boolean) {
  element.hidden = !isVisible
  element.ariaHidden = isVisible ? 'false' : 'true'
}

// Helper function to toggle label asterisk
function setLabelAsterisk(label: HTMLElement, showAsterisk: boolean) {
  const asterisk = ' <span class="text-danger">*</span>'
  const hasAsterisk = label.innerHTML.includes(asterisk)
  if (showAsterisk && !hasAsterisk) {
    label.innerHTML += asterisk
  } else if (!showAsterisk && hasAsterisk) {
    label.innerHTML = label.innerHTML.replace(asterisk, '')
  }
}

// Helper function to get element by ID or throw error
function getElementByIdOrThrow<T extends HTMLElement>(id: string): T {
  const element = document.getElementById(id) as T | null
  if (!element) throw new Error(`Element with ID '${id}' not found.`)
  return element
}

// Helper function to set required attribute
function setInputRequirement(input: HTMLInputElement, isRequired: boolean) {
  if (isRequired) {
    input.setAttribute('required', '')
  } else {
    input.removeAttribute('required')
  }
}

// Helper function to change form behaviour when `Other Accreditation Type` is selected
function toggleAccreditationTypeOther(selectedAccreditationType: string) {
  const isOther = selectedAccreditationType === ACCREDITATION_TYPE_OTHER

  const otherTypeInput = getElementByIdOrThrow<HTMLInputElement>(
    'id_accreditation-accreditation_type_other',
  )

  // Guaranteed to not be null
  const otherTypeParentContainer = otherTypeInput.parentElement!

  setInputRequirement(otherTypeInput, isOther)
  setElementVisibility(otherTypeParentContainer, isOther)
}

// Helper function to change form behaviour when IAS Accreditation Type is selected
function toggleAccreditationTypeIAS(selectedAccreditationType: string | null) {
  const isIAS = selectedAccreditationType === ACCREDITATION_TYPE_IAS

  // ID Form Element
  {
    const idInput = getElementByIdOrThrow<HTMLInputElement>(
      'id_accreditation-id_or_number',
    )
    setInputRequirement(idInput, isIAS)

    // Guaranteed to not be null
    const idParentContainer = idInput.parentElement!

    const idLabel = idParentContainer.querySelector(
      'label',
    ) as HTMLLabelElement | null
    if (!idLabel) throw new Error('IAS ID label element not found.')
    setLabelAsterisk(idLabel, isIAS)

    const helpText = idParentContainer.querySelector(
      '.help-text',
    ) as HTMLElement | null
    if (!helpText) throw new Error('IAS ID help element not found.')
    setElementVisibility(helpText, isIAS)

    // Hide/show error message for id-or-number
    const errorMessage = idParentContainer.querySelector(
      'small.form-text.text-danger',
    ) as HTMLElement | null
    if (errorMessage) {
      setElementVisibility(errorMessage, isIAS)
    }
  }

  // Date of Issue Form Element
  {
    const dateOfIssue = getElementByIdOrThrow<HTMLInputElement>(
      'id_accreditation-date_of_issue',
    )
    setElementVisibility(dateOfIssue, !isIAS)

    // Guaranteed to not be null
    const dateOfIssueParentContainer = dateOfIssue.parentElement!

    const dateOfIssueLabel = dateOfIssueParentContainer.querySelector(
      'label',
    ) as HTMLLabelElement | null
    if (!dateOfIssueLabel)
      throw new Error('Date of Issue label element not found.')
    setElementVisibility(dateOfIssueLabel, !isIAS)
  }

  // Date of Expiry Form Element
  {
    const dateOfExpiry = getElementByIdOrThrow<HTMLInputElement>(
      'id_accreditation-date_of_expiry',
    )
    setInputRequirement(dateOfExpiry, !isIAS)
    setElementVisibility(dateOfExpiry, !isIAS)

    // Guaranteed to not be null
    const dateOfExpiryParentContainer = dateOfExpiry.parentElement!

    const dateOfExpiryLabel = dateOfExpiryParentContainer.querySelector(
      'label',
    ) as HTMLLabelElement | null
    if (!dateOfExpiryLabel)
      throw new Error('Date of Expiry label element not found.')
    setElementVisibility(dateOfExpiryLabel, !isIAS)
    setLabelAsterisk(dateOfExpiryLabel, !isIAS)

    // Hide/show error message for date-of-expiry
    const errorMessage = dateOfExpiryParentContainer.querySelector(
      'small.form-text.text-danger',
    ) as HTMLElement | null
    if (errorMessage) {
      setElementVisibility(errorMessage, !isIAS)
    }
  }
}

function initAccreditation() {
  const accreditationType = document.getElementById(
    'id_accreditation-accreditation_type',
  ) as HTMLSelectElement

  document.addEventListener('DOMContentLoaded', () => {
    toggleAccreditationTypeOther(accreditationType.value)
    toggleAccreditationTypeIAS(accreditationType.value)
  })

  if (accreditationType) {
    accreditationType.addEventListener('change', function () {
      toggleAccreditationTypeOther(this.value)
      toggleAccreditationTypeIAS(this.value)
    })
  }
}

export { initAccreditation }
